import { memo, useCallback, useMemo } from 'react';
import {
	PERP_ORDER_TYPE_OPTIONS,
	SPOT_ORDER_TYPE_OPTIONS,
} from 'src/components/TradeForm/consts';
import BottomDrawerSelect from 'src/components/Inputs/BottomDrawerSelect/BottomDrawerSelect';
import { UIOrderType } from '@drift/common';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import { MarketType } from '@drift-labs/sdk';

interface Props {
	marketType: MarketType;
}

function BottomDrawerSelectOrderType({ marketType }: Props) {
	const set = useDriftStore((s) => s.set);
	const selectedOrderType = useDriftStore((s) => s.tradeForm.orderType);

	const options = useMemo(() => {
		const orderTypeOptions =
			marketType === MarketType.PERP
				? PERP_ORDER_TYPE_OPTIONS
				: SPOT_ORDER_TYPE_OPTIONS;

		return orderTypeOptions.map((orderType) =>
			orderType.value === 'takeProfitLimit'
				? // Abbreviate "Take Profit Limit" to be consistent with desktop.
					{ ...orderType, label: 'TP Limit' }
				: orderType
		);
	}, [marketType]);

	const selectedOrderTypeDisplay = useMemo(() => {
		return options.find((option) => option.value === selectedOrderType)?.label;
	}, [selectedOrderType, options]);

	const handleSelect = useCallback(
		(orderType: UIOrderType) => {
			set((s) => {
				s.tradeForm.orderType = orderType;
			});
		},
		[set]
	);

	return (
		<BottomDrawerSelect
			label="Order Type"
			triggerValue={selectedOrderTypeDisplay ?? ''}
			options={options}
			onSelect={handleSelect}
			selectedValue={selectedOrderType}
		/>
	);
}

export default memo(BottomDrawerSelectOrderType);
